import { ModelType } from '@/types';
import { agents } from './agent.model';
import { app } from './app.model';
import { brands } from './brand.model';
import { products } from './product.model';
import { showrooms } from './showroom.model';
import { storage } from './storage.model';

export const model: ModelType = {
  app,
  showrooms,
  storage,
  products,
  brands,
  agents,
};
